import { gql } from '@/__generated__/gql';

export const STRATEGY_DETAILS_PAGE_INVESTMENT_ENTITIES_BY_ADVISORY_FIRM_TOTAL_QUERY = gql(`
  query StrategyDetailsPageInvestmentEntitiesByAdvisoryFirmTotal($id: String!) {
    InvestmentEntitiesByAdvisoryFirm(id: $id) {
      total
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_COMMITMENTS_BY_INVESTOR_TOTAL_QUERY = gql(`
  query StrategyDetailsPageCommitmentsByInvestorTotal($investmentId: String!) {
    CommitmentsByInvestor(investmentId: $investmentId) {
      total
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_INVESTMENT_ENTITIES_TOTAL_QUERY = gql(`
  query StrategyDetailsPageInvestmentEntitiesTotal($id: String!) {
    InvestmentEntities(id: $id) {
      total
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_INVESTMENT_ENTITIES_QUERY = gql(`
  query StrategyDetailsPageInvestmentEntities(
    $id: String!
    $sort: String
    $order: String
    $search: String
    $quickFilter: String
    $page: Int
    $rowsPerPage: Int
    $vehicleFilter: [String!]
  ) {
    InvestmentEntities(
      id: $id
      sort: $sort
      order: $order
      search: $search
      quickFilter: $quickFilter
      page: $page
      rowsPerPage: $rowsPerPage
      vehicleFilter: $vehicleFilter
    ) {
      total
      page
      perPage
      entities {
        id
        name
        family
        familyId
        committedCapital
        capitalCalled
        percentOfCapitalCalled
        IRR
        TVPI
        tenant {
          name
        }
        vehicle
      }
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_INVESTMENT_ENTITIES_BY_ADVISORY_FIRM_QUERY = gql(`
  query StrategyDetailsPageInvestmentEntitiesByAdvisoryFirm(
    $id: String!
    $sort: String
    $order: String
    $search: String
    $quickFilter: String
    $page: Int
    $rowsPerPage: Int
    $vehicleFilter: [String!]
  ) {
    InvestmentEntitiesByAdvisoryFirm(
      id: $id
      sort: $sort
      order: $order
      search: $search
      quickFilter: $quickFilter
      page: $page
      rowsPerPage: $rowsPerPage
      vehicleFilter: $vehicleFilter
    ) {
      total
      page
      perPage
      firms {
        tenant {
          id
          name
        }
        investorEntities
        committedCapital
        capitalCalled
        percentOfCapitalCalled
        IRR
        TVPI
      }
      filters {
        name
        type
        value
        enabled
        count
      }
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_COMMITMENTS_BY_INVESTOR_QUERY = gql(`
  query StrategyDetailsPageCommitmentsByInvestor(
    $investmentId: String!
    $sort: String
    $order: String
    $search: String
    $quickFilter: String
    $page: Int
    $rowsPerPage: Int
    $vehicleFilter: [String!]
  ) {
    CommitmentsByInvestor(
      investmentId: $investmentId
      sort: $sort
      order: $order
      search: $search
      quickFilter: $quickFilter
      page: $page
      rowsPerPage: $rowsPerPage
      vehicleFilter: $vehicleFilter
    ) {
      total
      page
      perPage
      investors {
        investor {
          id
          name
        }
        tenant {
          name
        }
        committedCapital
        capitalCalled
        percentOfCapitalCalled
        investorEntities
      }
      filters {
        name
        type
        value
        enabled
        count
      }
    }
  }
`);
